exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rulePreview{font-size:14px;line-height:34px;color:#333333;display:inline-block}.rulePreview span{font-size:11px;padding:1px 4px;margin:0 4px;border-radius:4px;color:#ffffff}.rulePreview span.thingName{background-color:#0251bd}.rulePreview span.attribute{background-color:#673ab7;font-weight:600}.rulePreview span.operator{background-color:#4caf50;font-style:italic;text-transform:lowercase}.rulePreview span.value{font-size:14px;color:#1a76d4;background-color:transparent;font-weight:600;padding:4px}.rulePrev{padding:0px 25px 15px 15px}.ruleInfo{padding:15px 15px 15px 25px}.br+label{display:block;margin:0;height:30px;line-height:30px}.dot{color:black !important;margin:0 !important}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/common/rule-preview/rule-preview.component.scss
// module id = 1360
// module chunks = 1